import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import * as styles from 'styles/index.scss';
import { Collapse, Navbar, Nav, NavItem } from 'reactstrap';

const { wlcNavContainer } = styles;

const getContentSlug = pathname => pathname.split('/')[3] || '';

/**
 * WLCNav – Contextual "Back" navigation bar.
 */
const WLCNav = () => {
  const history = useHistory();
  const { pathname } = useLocation();
  const contentSlug = getContentSlug(pathname);

  const handleBack = () => {
    history.goBack();
    window.setTimeout(() => {
      window.scrollTo(0, 0);
    }, 0);
  };

  if (!contentSlug) return null;

  return (
    <div className={wlcNavContainer}>
      <Navbar light expand="md">
        <Collapse isOpen navbar>
          <Nav navbar>
            <NavItem onClick={handleBack} className="pl-md-5 pr-5 py-3">
              &lt; Back
            </NavItem>
          </Nav>
        </Collapse>
      </Navbar>
    </div>
  );
};

WLCNav.displayName = 'WLCNav';

export default WLCNav;
